export default __webpack_public_path__ + "static/media/termsImg.790e22bd.svg";